import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestResponse } from '../intefaces/requestResponse';
import { BaseService } from './base.service';
import { Subject } from 'rxjs';
import { Authorization } from '../intefaces/authorization';
import { BrowserStorageService } from './storage.service';
import { __APP_STORAGE_CART__ } from '../intefaces/const';
import { CartService } from './cart.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService extends BaseService {
  private loginObserver = new Subject<any>();

  constructor(protected http: HttpClient, private browserStorageService: BrowserStorageService, private cartService: CartService) {
    super();
  }

  public login(credentials) {
    return this.http.post<RequestResponse>(this.getUrl('login'), credentials);
  }

  public sendVefificationCode(credentials) {
    return this.http.post<RequestResponse>(this.getUrl('sendVefificationCode'), credentials);
  }

  public register(credentials) {
    return this.http.post<RequestResponse>(this.getUrl('register'), credentials);
  }

  public changePassword(credentials) {
    return this.http.post<RequestResponse>(this.getUrl('changePassword'), credentials);
  }

  public verifyChangePasswordCode(credentials) {
    return this.http.post<RequestResponse>(this.getUrl('verifyChangePasswordCode'), credentials);
  }

  public setCredential(credentials: Authorization) {
    this.browserStorageService.set("_login", credentials.login);
    this.browserStorageService.set("_token", credentials.token);
    this.browserStorageService.set("_role", credentials.role);
    this.setLoginObserver(true);
  }

  private setLoginObserver(isLogin) {
    this.loginObserver.next({
      login: isLogin
    });
  }

  public isLogin(): boolean {
    const login = this.browserStorageService.get("_token");
    if(login == null) {
      return false;
    }
    return true;
  }

  public logout(): void {
    this.browserStorageService.remove("_token");
    this.browserStorageService.remove("_role");
    this.browserStorageService.remove("_login");
    this.setLoginObserver(false);
    this.cartService.changeQuantity({ count: 0 });
  }

  public isLoginObservable() {
    return this.loginObserver.asObservable();
  }

}
